import { useModelContext } from '@app/contexts/model';
import { useStorageConfirmTranslateContext } from '@app/modules/ConfirmTranslate/contexts/storage';
import { ModalConfirm } from '@app/modules/Translate/components/ModalConfirmFiles/ModalConfirm';
import { ModalError } from '@app/modules/Translate/components/ModalConfirmFiles/ModalError';
import { ModalSuccess } from '@app/modules/Translate/components/ModalConfirmFiles/ModalSuccess';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IConfirmTranslateProps {}

export const ConfirmTranslate: FunctionComponent<IConfirmTranslateProps> = observer<FunctionComponent<IConfirmTranslateProps>>(function (props) {
    const { translateStore } = useStorageTranslateContext();
    const { languageFileModel } = useModelContext();
    const { authorizationModel } = useModelContext();
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();

    const user = authorizationModel.user.get();

    let tempFileNotDeleted = confirmTranslateStore.fileId && confirmTranslateStore.fileId.length != 2;

    let dataLanguageResponse = languageFileModel.dataLanguage.get() && tempFileNotDeleted;
    let inputChange = translateStore.changeSetBeforeAccept.size;

    let disabled = !dataLanguageResponse || inputChange > 0;

    const onClick = () => {
        translateStore.handleOpenConfirm();
    };

    return (
        <>
            {user.user.approval && (
                <IconButton disabled={disabled} className='featureButtons__i' aria-hidden='true' title='Confirm translation' onClick={onClick}>
                    <FontAwesomeIcon icon={faCheck} />
                </IconButton>
            )}
            <ModalConfirm />
            <ModalSuccess />
            <ModalError />
        </>
    );
});
